import { UGECropType } from '../types'

export function cropTypeFromAspectRatio(sourceRatio: number, ratio: number): UGECropType {
    const roundedSourceRatio = Math.round(sourceRatio * 100) / 100
    const roundedRatio = Math.round(ratio * 100) / 100

    if (roundedRatio === roundedSourceRatio) {
        return 'original'
    }

    if (roundedRatio === 1) {
        return 'square'
    }

    if (roundedRatio === Math.round((16 / 9) * 100) / 100) {
        return 'landscape'
    }

    if (roundedRatio === Math.round((9 / 16) * 100) / 100) {
        return 'portrait'
    }

    return 'custom'
}

export function aspectRatioFromCropType(crop: UGECropType, originalAspectRatio?: number): number | undefined {
    switch (crop) {
        case 'landscape':
            return 16 / 9
        case 'original':
            return originalAspectRatio || undefined
        case 'portrait':
            return 9 / 16
        case 'square':
            return 1
        default:
            return undefined
    }
}

export function labelFromCropType(cropType: UGECropType) {
    switch (cropType) {
        case 'custom':
            return 'Custom'
        case 'landscape':
            return 'Landscape'
        case 'original':
            return 'Original'
        case 'portrait':
            return 'Portrait'
        case 'square':
            return 'Square'
    }
}
